import type { ResourceStoreContext } from '@atlassian/jira-router';

export const getSpaRouterContext = ({ tenantContext }: ResourceStoreContext) => ({
	tenantContext,
});
